export const VENTES_PUBLISHED_STATUS = "published" as const;

import type { TirageInAuctionMapInput } from "@/lib/tirage-relation-mappers";

export type TirageAuctionPublicationCarrier = {
  auction?: { ventesPublicationStatus?: string | null };
};

/** Tirage ventes usable for provenance + auction compute fields after publish filter. */
export type TirageInAuctionForOverview = TirageAuctionPublicationCarrier &
  TirageInAuctionMapInput;

/**
 * Keeps published ventes. When `ventesPublicationStatus` is absent (API select or
 * needFrontPublic pre-filter), the row is kept so preview matches public CMS data.
 */
export function filterPublishedTirageInAuction<
  T extends TirageInAuctionForOverview = TirageInAuctionForOverview,
>(items?: readonly T[] | null): T[] {
  return (items ?? []).filter((item) => {
    const status = item.auction?.ventesPublicationStatus;
    if (status == null) return true;
    return status === VENTES_PUBLISHED_STATUS;
  });
}
